import React, { useState } from 'react';
import reactCSS from 'reactcss';

export interface FacebookSelectorEmojiProps {
  icon: string;
  label: string;
  onSelect?: (label: string) => void;
}

export const FacebookSelectorEmoji: React.FC<FacebookSelectorEmojiProps> = ({
  icon,
  label,
  onSelect,
}) =>
{
  const [isHover, setIsHover] = useState(false);
  const [isActive, setIsActive] = useState(false);

  const styles: any = (reactCSS as any)(
    {
      default: {
        wrap: {
          padding: '8px',
          position: 'relative' as const,
        },
        icon: {
          width: 'auto',
          height: '100%',
          minWidth: '24px',
          minHeight: '24px',
          backgroundImage: `url(${icon})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          transformOrigin: 'bottom' as const,
          cursor: 'pointer',
          transition: '200ms transform cubic-bezier(0.23, 1, 0.32, 1)',
        },
        label: {
          position: 'absolute' as const,
          top: '-22px',
          background: 'rgba(0,0,0,.8)',
          borderRadius: '14px',
          color: '#fff',
          fontSize: '11px',
          padding: '4px 7px 3px',
          fontWeight: 'bold' as const,
          textTransform: 'capitalize' as const,
          left: '50%',
          transform: 'translateX(-50%)',
          transition: '200ms transform cubic-bezier(0.23, 1, 0.32, 1)',
          opacity: '0',
          zIndex: 5,
        },
      },
      hover: {
        icon: {
          transform: 'scale(1.3)',
        },
        label: {
          transform: 'translateX(-50%) translateY(-10px)',
          opacity: '1',
        },
      },
    },
    { hover: isHover, active: isActive },
  );

  const handleClick = () =>
  {
    onSelect?.(label);
  };

  return (
    <div style={styles.wrap}>
      <div style={styles.label}>{label}</div>
      <div
        className="icon-reaction-chat"
        style={styles.icon}
        onClick={handleClick}
        onMouseEnter={() => setIsHover(true)}
        onMouseLeave={() => setIsHover(false)}
        onMouseDown={() => setIsActive(true)}
        onMouseUp={() => setIsActive(false)}
      />
    </div>
  );
};

export default FacebookSelectorEmoji;
